import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input"]

  static values = {
    lookupEnabled: Boolean,
    lookupUrl: String,
    currentId: String
  }

  connect() {
    this.normalizar()
  }

  normalizar() {
    this.inputTarget.value = this.valorNormalizado(this.inputTarget.value)
    this.limparErro()
  }

  validar() {
    const email = this.valorNormalizado(this.inputTarget.value)

    if (email.length === 0) {
      this.limparErro()
      this.limparAvisoCadastro()
      return
    }

    if (!this.emailValido(email)) {
      this.marcarErro("Email invalido")
      this.limparAvisoCadastro()
      return
    }

    this.limparErro()
  }

  async buscarCadastro() {
    if (!this.lookupEnabledValue) return
    if (!this.hasLookupUrlValue || !this.lookupUrlValue) return

    const email = this.valorNormalizado(this.inputTarget.value)

    if (!this.emailValido(email)) {
      this.limparAvisoCadastro()
      return
    }

    try {
      const url = new URL(this.lookupUrlValue, window.location.origin)
      url.searchParams.set("email", email)

      const response = await fetch(url.toString(), {
        headers: {
          Accept: "application/json",
          "X-Requested-With": "XMLHttpRequest"
        },
        credentials: "same-origin"
      })

      if (!response.ok) {
        this.limparAvisoCadastro()
        return
      }

      const data = await response.json()

      if (data.found && String(data.id) !== String(this.currentIdValue || "")) {
        this.mostrarAvisoCadastro(data)
      } else {
        this.limparAvisoCadastro()
      }
    } catch (_error) {
      this.limparAvisoCadastro()
    }
  }

  valorNormalizado(valor) {
    return String(valor || "").trim().toLowerCase()
  }

  emailValido(email) {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)
  }

  marcarErro(mensagem) {
    this.inputTarget.classList.add("is-invalid")
    this.feedbackElement().textContent = mensagem
  }

  limparErro() {
    this.inputTarget.classList.remove("is-invalid")
    this.feedbackElement().textContent = ""
  }

  feedbackElement() {
    let next = this.inputTarget.nextElementSibling

    if (next && next.classList.contains("invalid-feedback")) {
      return next
    }

    const div = document.createElement("div")
    div.className = "invalid-feedback"
    this.inputTarget.insertAdjacentElement("afterend", div)
    return div
  }

  mostrarAvisoCadastro(data) {
    const box = this.lookupElement()
    const nome = data.nome || "Pessoa ja cadastrada"
    const url = data.redirect_url

    box.innerHTML = url
      ? `Ja existe cadastro para <strong>${this.escapeHtml(nome)}</strong>. <a href="${this.escapeAttr(url)}">Abrir cadastro</a>`
      : `Ja existe cadastro para <strong>${this.escapeHtml(nome)}</strong>.`

    box.classList.remove("d-none")
  }

  limparAvisoCadastro() {
    const box = this.lookupElement()
    box.innerHTML = ""
    box.classList.add("d-none")
  }

  lookupElement() {
    let el = this.element.parentElement.querySelector(".email-lookup-feedback")
    if (el) return el

    el = document.createElement("div")
    el.className = "email-lookup-feedback alert alert-warning mt-2 mb-0 py-2 d-none"
    this.inputTarget.insertAdjacentElement("afterend", el)
    return el
  }

  escapeHtml(value) {
    const div = document.createElement("div")
    div.textContent = value || ""
    return div.innerHTML
  }

  escapeAttr(value) {
    return String(value || "").replace(/"/g, "&quot;")
  }
}
